module.exports = __webpack_public_path__ + "static/img/news.183799de.png";